import { Box, makeStyles, Typography } from '@material-ui/core';
import QRCodeStyling from 'qr-code-styling';
import React, { useEffect, useMemo, useRef } from 'react';
import { getBackofficePublicUrl } from '../../utils/pwa';

const QR_SIZE = 180;

const useStyles = makeStyles(() => ({
    container: {
        display: 'grid',
        justifyItems: 'center',
        gap: 12,
        padding: '8px 0 4px',
    },
    qrWrapper: {
        padding: 12,
        backgroundColor: '#ffffff',
        border: '1px solid #e9ecef',
        borderRadius: 8,
    },
    url: {
        fontSize: '0.75rem',
        color: '#6c757d',
        wordBreak: 'break-all',
        textAlign: 'center',
        maxWidth: '100%',
    },
}));

interface BackofficeUrlQrCodeProps {
    url?: string;
}

const BackofficeUrlQrCode: React.FC<BackofficeUrlQrCodeProps> = ({ url }) => {
    const classes = useStyles();
    const qrContainerRef = useRef<HTMLDivElement>(null);
    const backofficeUrl = useMemo(() => url || getBackofficePublicUrl(), [url]);

    useEffect(() => {
        if (!qrContainerRef.current || !backofficeUrl) {
            return;
        }

        const qrCode = new QRCodeStyling({
            width: QR_SIZE,
            height: QR_SIZE,
            data: backofficeUrl,
            margin: 4,
            qrOptions: {
                errorCorrectionLevel: 'M',
            },
            dotsOptions: {
                color: '#000000',
                type: 'square',
            },
            backgroundOptions: {
                color: '#ffffff',
            },
        });

        qrContainerRef.current.innerHTML = '';
        qrCode.append(qrContainerRef.current);
    }, [backofficeUrl]);

    return (
        <Box className={classes.container}>
            <Box className={classes.qrWrapper}>
                <div
                    ref={qrContainerRef}
                    style={{
                        width: QR_SIZE,
                        height: QR_SIZE,
                    }}
                />
            </Box>
            <Typography className={classes.url}>{backofficeUrl}</Typography>
        </Box>
    );
};

export default BackofficeUrlQrCode;
